import { loadGetSocialJS, initGetSocialSDK } from '~/tools/analytics/getSocial'
import get from 'lodash/get';
import userStore from '~/redux/user/store';
import getQueryVariable from '~/tools/getQueryVariable';
import Cookie from 'js-cookie';

export const setGetSocialCId = () => {
    const getSocialAppId = window.settings.notifications && window.settings.notifications.getSocialAppId;
    if(!getSocialAppId) return;
    const gs_cid = getSocialAppId && getQueryVariable('_gs_cid');
    if(!gs_cid) return;
    gs_cid && localStorage.setItem('gs_cid', gs_cid);
    gs_cid && Cookie.set('referralPlanPage', window.location.pathname);
    initGetSocialSDK(getSocialAppId); // Need to initialise SDK as per discussion with GetSocial team.
}

export const getGetSocialCId = () => {
    const getSocialAppId = window.settings.notifications && window.settings.notifications.getSocialAppId;
    return getSocialAppId && localStorage.getItem('gs_cid') ? localStorage.getItem('gs_cid'): '';
}

export const getSocialEvent = (eventName, messageDisplayed, planId) => {
    const gs_cid = getGetSocialCId();
    const getSocialAppId = window.settings.notifications && window.settings.notifications.getSocialAppId;

    if (gs_cid && getSocialAppId) {
        const user = userStore && userStore.getState().user;
        const userId = user && user.userId;
        userId && loadCustomEventWebHookSDK(getSocialAppId, gs_cid, eventName, messageDisplayed, planId);
    }
}

export const loadCustomEventWebHookSDK = (getSocialAppId, gs_cid, eventName, messageDisplayed, planId) => {
    if(getSocialAppId) {
        loadGetSocialJS()
        .then(()=> {
            var socialSDKObj =  new window.GetSocialSDK({appId: getSocialAppId});
            if(socialSDKObj) { 
                authenticateNewRegisterUser(socialSDKObj, gs_cid, eventName, messageDisplayed, planId);
            }
        })
        .catch(function (error) {
            console.error('Unable to load GetSocial SDK: ' + error);
        });  
    }
}
//End loading GetSocial SDK 

// Start Authenticating New User
export const authenticateNewRegisterUser = (socialSDKObj, cid, eventName, messageDisplayed, planId) => {
    if(socialSDKObj) {
        const isOTPEnabled = get(window.settings, 'features.otp_value.otp_enabled');
        const user = userStore && userStore.getState().user;
        const userId = user && user.userId;
        const name = user && user.name;
        const userEmail = user && user.email;
        const userPhoneNumber = user && user.phoneNumber;

        const custom_data = {
            "userId": userId,
            "name": name,
            "email": userEmail,
            "phone": userPhoneNumber ? userPhoneNumber : '',
            "isOTPEnabled": isOTPEnabled.toString(),
            "app_platform": "Web",
            "url": cid,
            "planId":planId
        };
        
        const newUser = true;

        const authenticationParams = {
            "identity_type": "viewlift",
            "value": userId,
            "token": userId,
            "new_user": newUser,
            "url": cid,
            "custom_data": custom_data
        };
        
        socialSDKObj.auth.authenticate(authenticationParams)
        .then((response) => {
            const authenticatedUserId = response.user.id;
            if(authenticatedUserId) {
                trackGetSocialEvent(socialSDKObj, user, cid, eventName, messageDisplayed, planId);
            }
        })
        .catch((error) => {
            console.error('GetSocial Authentication issue:' + error);
        }); 
    }
}
//End Authenticating New User

// Start Track Custom Event
export const trackGetSocialEvent = (socialSDKObj, user, cid, eventName, messageDisplayed, planId) => {

    if(socialSDKObj) {

        const isOTPEnabled = get(window.settings, 'features.otp_value.otp_enabled');
        const userId = user && user.userId;
        const name = user && user.name;
        const userEmail = user && user.email;
        const userPhoneNumber = user && user.phoneNumber;

        const custom_data = {
            [eventName] : messageDisplayed,
            "userId": userId,
            "name": name,
            "email": userEmail,
            "phone": userPhoneNumber ? userPhoneNumber : '',
            "isOTPEnabled": isOTPEnabled.toString(),
            "app_platform": "Web",
            "url": cid,
            "planId":planId
        };

        var customEvents = [
            {
                "name": eventName,
                "custom_data": custom_data
            }
        ];
        socialSDKObj.analytics.trackCustomEvents(customEvents)
        .then(function (response) {
        })
        .catch(function (error) {
            console.error('GetSocial Custom Events error:', error);
        });
    }
}
// End Track Custom Event

/**
 Check and redirect to referral plan page function. 
 */
export const checkAndRedirectReferralPlanPage = () => {
    const getSocialCId = getGetSocialCId();
    if (getSocialCId) {
        const referralPlanPage = Cookie.get('referralPlanPage') ? Cookie.get('referralPlanPage') : '';
        if (window.location.pathname && referralPlanPage && (window.location.pathname === referralPlanPage)) {
            return referralPlanPage;
        } else {
            return false;
        }
    } else {
        return false;
    }
}